import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-qa-value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")

  return ($props.validatorLayout === 'default')
    ? (_openBlock(), _createElementBlock("p", {
        key: 0,
        class: "gfu-field__error",
        "data-qa-value": $options.validationMessage,
        "data-qa": "field-error"
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 8 /* PROPS */, _hoisted_1))
    : ($props.validatorLayout === 'tooltip')
      ? (_openBlock(), _createBlock(_component_tooltip, {
          key: 1,
          class: "gfu-field__error gfu-field__error--tooltip",
          theme: "error",
          "vertical-position": "down",
          "data-qa-value": $options.validationMessage,
          text: $options.validationMessage,
          "data-qa": "field-error"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_icon, { name: "circle-info" })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["data-qa-value", "text"]))
      : _createCommentVNode("v-if", true)
}